import React from 'react';
import logo from './logo.svg';
import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Router from './Router';
import { Toaster } from 'react-hot-toast';
import { AllowedPagesProvider } from './context/AllowedPagesContext';

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
      <AllowedPagesProvider>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </AllowedPagesProvider>
    </div>
  );
}

export default App;
